import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';


@Component({
	selector: 'app-external-link',
	templateUrl: './external-link.component.html',
	styleUrls: ['./external-link.component.scss']
})
export class ExternalLinkComponent {
	@Input() text: string;
	@Input() link: any;
	@Input() isExternalLink: boolean = true;
	@Input() download: boolean = false;

	constructor(private sanitizer: DomSanitizer)
	{

	}

	safeUrl = () => {		
		return this.sanitizer.sanitize(SecurityContext.URL, this.link);
	}
}
